







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BuilderDot extends Vue {
  @Prop({default: 'auto', type: String}) left!: string
  @Prop({default: 'auto', type: String}) right!: string
  @Prop({default: 'auto', type: String}) top!: string
  @Prop({default: 'auto', type: String}) bottom!: string
}
